import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import ConditionalWrapper from './../components/ConditionalWrapper';
import ButtonCircularProgress from "./ButtonCircularProgress";

const ArrowRight = () => <svg className="arrowRight" xmlns="http://www.w3.org/2000/svg" width="10.723" height="17.661" viewBox="0 0 10.723 17.661">
    <g id="icon_goto" transform="rotate(180 8.386 9.422)">
        <path id="Trazado_3218" d="M6.417 9.322l4.993 5.447 4.99-5.447" className="cls-1" transform="translate(0 3.336)" />
        <path id="Trazado_3217" d="M9.959 17.345V1.184" className="cls-1" transform="translate(1.452)" />
    </g>
</svg>;



export default styled(({ className, to, label, submit, disabled = false, loading = false, onClick, style }) => <ConditionalWrapper
    condition={to ? true : false}
    defaultWrapper={children => <span className={className} style={style}>{children}</span>}
    wrapper={children => <Link to={to} className={className} style={style}>{children}</Link>}
>
    <Button
        style={{ textTransform: 'none', color: 'unset' }}
        variant={"text"}
        color={"primary"}
        size="large"
        align={"center"}
        type={submit ? 'submit' : 'button'}
        disabled={disabled || loading}
        onClick={onClick}
    >
        {label}
        {(!loading && <ArrowRight />) || <ButtonCircularProgress />}
    </Button>
</ConditionalWrapper>)`
    margin-left: -8px;
    height: 19px;
    font-family: Lato;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #b08f6e;
    text-decoration: none !important;

    button:disabled{
        opacity: 0.5;
    }
    
    .arrowRight{
        width: 10px;
        height: 16.9px;
        object-fit: contain;
        transform: rotate(90deg);
        margin-left: 12px;
        vertical-align: middle;

        .cls-1{
            fill:none;
            stroke:#b08f6e;
        }
    }
`;